import { render, staticRenderFns } from "./billStat.vue?vue&type=template&id=305f6ad6&scoped=true"
import script from "./billStat.vue?vue&type=script&lang=js"
export * from "./billStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305f6ad6",
  null
  
)

export default component.exports